/*
 *
 * ApiKeys actions
 *
 */

import {
  ENABLE_LOADER,
  DISABLE_LOADER,
  DEFAULT_ACTION,
  FETCH_API_KEYS,
  SET_ACTIVE_NAVIGATION,
  SAVE_FETCH_API_KEYS_RESPONSE,
  GENERATE_API_KEY,
  SAVE_GENERATE_API_KEY_RESPONSE,
  RESET_API_KEY,
  SAVE_RESET_API_KEY_RESPONSE,
  RESET_RESPONSE,
  UPDATE_TABLE_DATA,
  GET_API_KEY_BY_APP_ID,
  SAVE_GET_API_KEY_BY_APP_ID_RESPONSE,
  RESET_DATA,
} from './constants';

export function defaultAction() {
  return {
    type: DEFAULT_ACTION,
  };
}

export function setActiveNavigationAction(activeNavigation) {
  return {
    type: SET_ACTIVE_NAVIGATION,
    data: activeNavigation,
  };
}

export function updateTableDataAction(data) {
  return {
    type: UPDATE_TABLE_DATA,
    data,
  };
}

export function fetchAPIKeysAction(data) {
  return {
    type: FETCH_API_KEYS,
    data,
  };
}
export function fetchAPIKeysSaveResponseAction(data) {
  return {
    data,
    type: SAVE_FETCH_API_KEYS_RESPONSE,
  };
}
export function generateAPIKeyAction(data) {
  return {
    type: GENERATE_API_KEY,
    data,
  };
}
export function generateAPIKeySaveResponseAction(data) {
  return {
    data,
    type: SAVE_GENERATE_API_KEY_RESPONSE,
  };
}

export function resetAPIKeyAction(data) {
  return {
    data,
    type: RESET_API_KEY,
  };
}
export function resetAPIKeySaveResponseAction(data) {
  return {
    data,
    type: SAVE_RESET_API_KEY_RESPONSE,
  };
}

export function resetResponseAction() {
  return {
    type: RESET_RESPONSE,
  };
}

export function enableLoaderAction() {
  return {
    type: ENABLE_LOADER,
  };
}

export function disableLoaderAction() {
  return {
    type: DISABLE_LOADER,
  };
}

export function getApiKeyByAppIdAction(data) {
  return {
    type: GET_API_KEY_BY_APP_ID,
    data,
  };
}

export function saveGetApiKeyByAppIdResponse(data) {
  return {
    type: SAVE_GET_API_KEY_BY_APP_ID_RESPONSE,
    data,
  };
}

export function resetDataAction() {
  return {
    type: RESET_DATA,
  };
}
